import React, { Component } from "react";
import ExportSupplierComp from "../../../components/suppliers/export";

export default class ExportSupplier extends Component {
  render() {
    return <ExportSupplierComp />;
  }
}
